import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from './service/user.service';
import { Log } from './util/log';
import { Gtag } from 'angular-gtag';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { mergeMapTo } from 'rxjs/operators';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {

  currentLanguage: string;
  private headerReady$ = new ReplaySubject<void>(1); // emits when Header is ready


  constructor(private domSanitizer: DomSanitizer, private matIconRegistry: MatIconRegistry, private userService: UserService, private router: Router, gtag: Gtag, private afMessaging: AngularFireMessaging) {

    Log.debug("AppComponent constructor");

    // devo importare gtag nel costruttore altrimenti non va

    // this.afMessaging.requestPermission
    // .pipe(mergeMapTo(this.afMessaging.tokenChanges))
    // .subscribe(
    //   (token) => {

    //     console.log('Permission granted! Save to the server!', token);
    //     // Once you have a user's token, you need to save it to the server in order
    //     // to send them notifications in response to events.

    //   },
    //   (error) => {
    //     console.error(error);
    //   },
    // );
    this.matIconRegistry.addSvgIcon(
      "why",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/font/why.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "why2",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/font/why2.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "jcm",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/font/jcm.svg")
    );
  }

  notifyHeaderReady() {
    this.headerReady$.next();
  }


  waitForHeaderReady() {
    return this.headerReady$.asObservable();
  }

  listen() {

    this.afMessaging.messages.subscribe((message) => {

      // console.log(message);
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  public setCurrentLanguage(language: string): void {
    this.currentLanguage = language.toUpperCase();
  }

  public getCurrentLanguage(): string {
    return this.currentLanguage;
  }

  public logout() {

    this.userService.logout().then(() => {

      this.router.navigate(['login']);
      location.reload();

    }).catch((error) => {
      // TODO
    });
  }

  public logoutSilent() {
    if(this.userService.isLoggedIn){

      Log.debug("Is logged in");
      this.userService.logout().then(() => {

        location.reload();
      }).catch((error) => {
        Log.debug("Error in logoutSilent");
        Log.debug(error);
      });
    } else {
      Log.debug("Not logged in");

    }
  }

  public isLoggedIn(): boolean {

    return this.userService.isLoggedIn;
  }

  public isAdmin(): boolean {

    return this.userService.isAdmin;
  }

  public isService(): boolean {
    return this.userService.isService;
  }

  public isAliasNow(): boolean {
    return this.userService.isAlias;
  }

  public async isAlias(): Promise<boolean> {
    return await this.userService.isAliasAsync();
  }



  onActivate(event) {
    // window.scroll(0,0);
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
